<template>
  <div>
    <Drawer
      :title="title"
      :closable="true"
      v-model="show"
      width="95"
      :mask-closable="false"
    >
      <div>
        <Upload multiple type="drag" action="//jsonplaceholder.typicode.com/posts/">
          <div style="padding: 100px 0">
            <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
            <p>点击此处上传或将文件拖到此处上传</p>
          </div>
        </Upload>
      </div>
    </Drawer>
  </div>
</template>

<script>
export default {
  name: "import_excel_v1",
  data() {
    return {
      title: "Excel导入",
      show: false,
      
    };
  },
};
</script>

<style scoped></style>
